'use client';

/**
 * Flutter 侧已实现、Web 侧尚未做像素级对齐的组件占位。
 * 避免整树渲染失败，便于逐步补齐。
 */
export function MacaronStub({ name }: { name: string }) {
  const processEnv = (globalThis as typeof globalThis & { process?: { env?: { NODE_ENV?: string } } }).process?.env;
  if (processEnv?.NODE_ENV === 'production') {
    return null;
  }
  return <div className="rounded border border-dashed border-amber-300/80 bg-amber-50/50 px-2 py-1 font-mono text-[11px] text-amber-900">Macaron widget not implemented: {name}</div>;
}
